class CocktailRecipe extends HTMLElement {
  constructor() {
    super();
    this.serves = 'x1';
    this.units = 'mL';
  }

  connectedCallback() {
    this.bindControls();
    this.updateIngredients();
  }

  bindControls() {
    this.querySelectorAll('[data-recipe-serve]').forEach((button) => {
      button.addEventListener('click', () => {
        this.serves = button.dataset.recipeServe || 'x1';
        this.setPressed('[data-recipe-serve]', button);
        this.updateIngredients();
      });
    });

    this.querySelectorAll('[data-recipe-unit]').forEach((button) => {
      button.addEventListener('click', () => {
        this.units = button.dataset.recipeUnit || 'mL';
        this.setPressed('[data-recipe-unit]', button);
        this.updateIngredients();
      });
    });
  }

  setPressed(selector, activeButton) {
    this.querySelectorAll(selector).forEach((button) => {
      const pressed = button === activeButton;
      button.setAttribute('aria-pressed', pressed ? 'true' : 'false');
      button.classList.toggle('is-active', pressed);
    });
  }

  updateIngredients() {
    const multiplier = Number(this.querySelector(`[data-recipe-serve="${this.serves}"]`)?.dataset.multiplier || 1);

    this.querySelectorAll('[data-recipe-ingredient-qty]').forEach((badge) => {
      const fixedUnit = badge.dataset.fixedUnit;
      const baseQty = Number(badge.dataset.baseQty);

      if (fixedUnit) {
        badge.textContent = fixedUnit;
        return;
      }

      if (!Number.isFinite(baseQty)) {
        badge.textContent = '-';
        return;
      }

      const scaled = baseQty * multiplier;
      badge.textContent = this.units === 'oz' ? `${(scaled * 0.033814).toFixed(1)} oz` : `${scaled} mL`;
    });

    this.querySelectorAll('[data-recipe-serves-label]').forEach((label) => {
      label.textContent = this.querySelector(`[data-recipe-serve="${this.serves}"]`)?.textContent?.trim() || 'x1';
    });

    this.querySelectorAll('[data-recipe-units-label]').forEach((label) => {
      label.textContent = this.units;
    });
  }
}

if (!customElements.get('cocktail-recipe')) {
  customElements.define('cocktail-recipe', CocktailRecipe);
}
